import { connect } from "react-redux";
import { unwatch } from "project/ducks/watchlist";
import WatchlistProjects from "your_projects/components/watchlist_projects";

const mapStateToProps = ({ categories }) => {
  return {
    categories,
  };
};

export default connect(mapStateToProps, { unwatch })(WatchlistProjects);
